import { createElement } from "react"
import { toast } from "react-toastify"

import { NotificationError } from "./components"
import { CustomError } from "./types"

const displayNotificationError = (error: CustomError) => {
    toast.error(createElement(NotificationError, { error }), {
        closeOnClick: false,
        className: "w-full md:w-3/6",
    })
}

export { displayNotificationError }
